'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('./baseEntity'),
    BaseEntity = _require.BaseEntity;

var _require2 = require('../resource'),
    ProjektleiterResource = _require2.ProjektleiterResource;

module.exports.Projektleiter = function (_BaseEntity) {
  _inherits(Projektleiter, _BaseEntity);

  _createClass(Projektleiter, null, [{
    key: '__name__',
    value: function __name__() {
      return 'projektleiter';
    }
  }]);

  function Projektleiter(data) {
    _classCallCheck(this, Projektleiter);

    var _this = _possibleConstructorReturn(this, (Projektleiter.__proto__ || Object.getPrototypeOf(Projektleiter)).call(this));

    _this._entityName = 'de.ul.fob.domain.Projektleiter';
    _this.rolle = 'GESAMTLEITUNG';
    _this.startdatum = null;
    _this.enddatum = null;
    // this is a preliminary ID for newly created projektleiter entities
    // that to will be discarded once it is persisted to the database
    _this._id = '__' + Date.now() + '-' + Math.floor(Math.random() * 1000000);

    _this.person = null;
    _get(Projektleiter.prototype.__proto__ || Object.getPrototypeOf(Projektleiter.prototype), 'init', _this).call(_this, data);
    return _this;
  }

  _createClass(Projektleiter, [{
    key: 'toPostData',
    value: function toPostData() {
      return this.genericJSON({
        fields: ['_id', 'rolle', 'startdatum', 'enddatum'],
        links: ['person']
      });
    }
  }, {
    key: 'fetchPersonIdent',
    value: function fetchPersonIdent() {
      return _get(Projektleiter.prototype.__proto__ || Object.getPrototypeOf(Projektleiter.prototype), 'genericResolve', this).call(this, 'person');
    }
  }, {
    key: 'fetchAll',
    value: function fetchAll() {
      return Promise.all([_get(Projektleiter.prototype.__proto__ || Object.getPrototypeOf(Projektleiter.prototype), 'genericResolve', this).call(this, 'person')]);
    }
  }, {
    key: 'fetchResource',
    value: function fetchResource() {
      if (typeof Projektleiter === 'undefined') {
        return this.fetchAll();
      } else {
        return _get(Projektleiter.prototype.__proto__ || Object.getPrototypeOf(Projektleiter.prototype), 'fetchQuery', this).call(this, ProjektleiterResource);
      }
    }
  }]);

  return Projektleiter;
}(BaseEntity);


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/projektleiter.js
// module id = BYWM
// module chunks = 0